// extracted by mini-css-extract-plugin
export var phone = "_31-0";